module.exports = __webpack_public_path__ + "static/media/blaffende_hond.f0af78b8.mp3";